import { Component } from '@angular/core';
import { MetforminComponent } from '@consultation-upsells/metformin/metformin.component';

@Component({
  selector: 'app-metformin-hair-loss',
  imports: [MetforminComponent],
  templateUrl: './metformin-hair-loss.component.html',
})
export class MetforminHairLossComponent {}
